export const FRONTEND_SKILLS = [
  {
    label: "HTML",
    proficiency: "100%",
    icon: "vscode-icons:file-type-html",
    iconClasses: "text-3xl",
  },
  {
    label: "CSS",
    proficiency: "100%",
    icon: "vscode-icons:file-type-css",
    iconClasses: "text-3xl",
  },
  {
    label: "Javascript",
    proficiency: "100%",
    icon: "logos:javascript",
    iconClasses: "text-2xl",
  },
  {
    label: "Typescript",
    proficiency: "95%",
    icon: "logos:typescript-icon",
    iconClasses: "text-2xl",
  },
  {
    label: "React.js",
    proficiency: "100%",
    icon: "vscode-icons:file-type-reactjs",
    iconClasses: "text-2xl",
  },
  {
    label: "Next.js",
    proficiency: "88%",
    icon: "cib:next-js",
    iconClasses: "text-3xl",
  },
  {
    label: "Vue.js",
    proficiency: "88%",
    icon: "cib:vue-js",
    iconClasses: "text-3xl",
  },
  {
    label: "Gatsby",
    proficiency: "72%",
    icon: "logos:gatsby",
    iconClasses: "text-3xl",
  },
  {
    label: "Material UI (mui)",
    proficiency: "83%",
    icon: "logos:material-ui",
    iconClasses: "text-2xl",
  },
  {
    label: "Tailwind CSS",
    proficiency: "100%",
    icon: "logos:tailwindcss-icon",
    iconClasses: "text-2xl",
  },
  {
    label: "Angular",
    proficiency: "100%",
    icon: "logos:angular-icon",
    iconClasses: "text-2xl",
  },
  {
    label: "SCSS",
    proficiency: "94%",
    icon: "vscode-icons:file-type-scss2",
    iconClasses: "text-3xl",
  },
  {
    label: "Bootstrap",
    proficiency: "91%",
    icon: "logos:bootstrap",
    iconClasses: "text-2xl",
  },
  {
    label: "Redux",
    proficiency: "100%",
    icon: "logos:redux",
    iconClasses: "text-3xl",
  },
  {
    label: "WordPress",
    proficiency: "100%",
    icon: "ic:twotone-wordpress",
    iconClasses: "text-3xl",
  },
  {
    label: "BackBone.js",
    proficiency: "100%",
    icon: "logos:backbone-icon",
    iconClasses: "text-3xl",
  },
  {
    label: "SEO",
    proficiency: "100%",
    icon: "tabler:seo",
    iconClasses: "text-3xl",
  },
];

export const BACKEND_SKILLS = [
  {
    label: "Node.js",
    proficiency: "100%",
    icon: "vscode-icons:file-type-node",
    iconClasses: "text-3xl",
  },
  {
    label: "Express (Node.js Framework)",
    proficiency: "100%",
    icon: "simple-icons:express",
    iconClasses: "text-3xl",
  },
  {
    label: "PHP",
    proficiency: "100%",
    icon: "vscode-icons:file-type-php",
    iconClasses: "text-4xl",
  },
  {
    label: "Laravel",
    proficiency: "100%",
    icon: "logos:laravel",
    iconClasses: "text-3xl",
  },
  {
    label: "RESTful Api",
    proficiency: "100%",
    icon: "dashicons:rest-api",
    iconClasses: "text-3xl",
  },
  {
    label: "Graphql",
    proficiency: "78%",
    icon: "logos:graphql",
    iconClasses: "text-3xl",
  },
  {
    label: "Sequelize",
    proficiency: "95%",
    icon: "vscode-icons:file-type-sequelize",
    iconClasses: "text-3xl",
  },
  {
    label: "PostgreSQL",
    proficiency: "90%",
    icon: "vscode-icons:file-type-pgsql",
    iconClasses: "text-3xl",
  },
  {
    label: "MySQL",
    proficiency: "97%",
    icon: "logos:mysql",
    iconClasses: "text-2xl",
  },
  {
    label: "MongoDB",
    proficiency: "98%",
    icon: "vscode-icons:file-type-mongo",
    iconClasses: "text-3xl",
  },
  {
    label: "Github",
    proficiency: "90%",
    icon: "akar-icons:github-fill",
    iconClasses: "text-3xl",
  },
  {
    label: "Docker",
    proficiency: "72%",
    icon: "logos:docker-icon",
    iconClasses: "text-2xl",
  },
  {
    label: "AWS",
    proficiency: "80%",
    icon: "logos:aws",
    iconClasses: "text-xl",
  },
  {
    label: "Heroku",
    proficiency: "70%",
    icon: "logos:heroku-icon",
    iconClasses: "text-2xl",
  },
  {
    label: "Vercel",
    proficiency: "90%",
    icon: "logos:vercel-icon",
    iconClasses: "text-2xl",
  },
  {
    label: "Elixir",
    proficiency: "90%",
    icon: "devicon:elixir",
    iconClasses: "text-2xl",
  },
];

export const BLOCKCHAIN_SKILLS = [
  {
    label: "Blockchain",
    proficiency: "90%",
    icon: "eos-icons:blockchain",
    iconClasses: "text-3xl",
  },
  {
    label: "Ethereum",
    proficiency: "95%",
    icon: "logos:ethereum",
    iconClasses: "text-3xl",
  },
  {
    label: "Solidity",
    proficiency: "100%",
    icon: "logos:solidity",
    iconClasses: "text-3xl",
  },
  {
    label: "Web3",
    proficiency: "100%",
    icon: "logos:web3js",
    iconClasses: "text-3xl",
  },
  {
    label: "Hardhat",
    proficiency: "93%",
    icon: "vscode-icons:file-type-hardhat",
    iconClasses: "text-3xl",
  },
  {
    label: "Truffle",
    proficiency: "88%",
    icon: "logos:truffle-icon",
    iconClasses: "text-3xl",
  },
  {
    label: "Solana",
    proficiency: "90%",
    icon: "mingcute:solana-sol-fill",
    iconClasses: "text-3xl",
  },
  {
    label: "Rust",
    proficiency: "87%",
    icon: "vscode-icons:file-type-rust",
    iconClasses: "text-2xl",
  },
  {
    label: "Cardano",
    proficiency: "70%",
    icon: "logos:cardano-icon",
    iconClasses: "text-3xl",
  },
  {
    label: "Haskell (Plutus)",
    proficiency: "60%",
    icon: "vscode-icons:file-type-haskell2",
    iconClasses: "text-xl",
  },
];
export const GAME_SKILLS = [
  {
    label: "Unity",
    proficiency: "89%",
    icon: "fa-brands:unity",
    iconClasses: "text-3xl",
  },
  {
    label: "C#",
    proficiency: "84%",
    icon: "vscode-icons:file-type-csharp2",
    iconClasses: "text-3xl",
  },
  {
    label: "Three.js",
    proficiency: "92%",
    icon: "skill-icons:threejs-dark",
    iconClasses: "text-3xl",
  },
  {
    label: "PixiJs",
    proficiency: "96%",
    icon: "logos:pixijs",
    iconClasses: "text-xs",
  },
  {
    label: "Cocos",
    proficiency: "85%",
    icon: "simple-icons:cocos",
    iconClasses: "text-3xl",
  },
  {
    label: "3D max",
    proficiency: "60%",
    icon: "vscode-icons:file-type-maxscript",
    iconClasses: "text-3xl",
  },
  {
    label: "Socket-io",
    proficiency: "100%",
    icon: "logos:socket-io",
    iconClasses: "text-3xl",
  },
];
export const FRONTEND_DESCRIPTIONS = [
  "Web development with a focus on search engine optimization (SEO).",
  "Building responsive SPA interfaces using React.js and Next.js",
  "Experience in large web applications using Redux to implement standard dataflow constructs.",
  "Good experience building web Games using various Javascript libraries",
];

export const BACKEND_DESCRIPTIONS = [
  "Implementation of RESTful API and GraphQL API.",
  "Building servers that provide fast response and strong security.",
  "Rich experience with relational and non-relational databases such as MongoDB and MySQL.",
];

export const BLOCKCHAIN_DESCRIPTIONS = [
  "Solid fundamental technology of Blockchain and Web3",
  "Developing precise and transparent smart contracts on the several networks.",
  "Building impactful and trustworthy decentralized applications(dApp)",
  "Developing aComprehensive protocol containing NFT, P2E Games and Web3.",
];
export const GAME_DESCRIPTIONS = [
  "Building 2D and 3D Games using Unity and Cocos.",
  "Good experience building web Games using various Javascript libraries",
  "Developing aComprehensive protocol containing NFT, P2E Games and Web3.",
];

export const SKILL_CATEGORY = {
  FRONTEND: 0,
  BACKEND: 1,
  BLCOKCHAIN: 2,
};

export const SkillTABS = [
  {
    label: "Frontend",
    value: SKILL_CATEGORY.FRONTEND,
  },
  {
    label: "Backend",
    value: SKILL_CATEGORY.BACKEND,
  },
  {
    label: "Blockchain",
    value: SKILL_CATEGORY.BLCOKCHAIN,
  },
];
